import { compose } from "recompact"
import * as entity from "src/engine/modules/entity"
import eventTypeModel from "src/models/eventType"
import collection from "src/hocs/collection"
import isFunction from "lodash/isFunction"

const configuration = {
  engine: entity,
  to: `eventTypes`,
  model: eventTypeModel,
}

export default config =>
  compose(
    collection(props => ({
      ...configuration,
      ...(isFunction(config) ? config(props) : config),
    })),
  )
